export default __webpack_public_path__ + "static/media/Trustpilot dark.ec358382.svg";